import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _BaseSetting;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import t from '@instructure/quiz-i18n/format-message';
import { Checkbox } from '@instructure/ui-checkbox';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Text } from '@instructure/ui-text';
import { View } from '@instructure/ui-view';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';

// This is defined outside of the component so all instances of Setting
// call the same debounced method. Otherwise, each setting would trigger
// its own alert on a 3s debounce, which we don't want.
var debouncedAddSuccess = debounce(function (addSuccess) {
  addSuccess(t.rich('<0>Success!</0> Your quiz has been saved.', [function (_ref) {
    var children = _ref.children;
    return jsx(Text, {
      weight: "bold",
      key: "0"
    }, children);
  }]));
}, 3000);
var BaseSetting = /*#__PURE__*/function (_Component) {
  function BaseSetting() {
    var _this2;
    _classCallCheck(this, BaseSetting);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, BaseSetting, [].concat(args));
    _defineProperty(_this2, "handleChangeComplete", function () {
      debouncedAddSuccess(_this2.props.addSuccess);
    });
    _defineProperty(_this2, "handleChange", function (e) {
      _this2.props.onChange(e, _this2.handleChangeComplete);
    });
    return _this2;
  }
  _inherits(BaseSetting, _Component);
  return _createClass(BaseSetting, [{
    key: "renderChildren",
    value: function renderChildren() {
      if (!this.props.showMore) {
        return null;
      }
      return jsx("div", {
        className: "detailsWrapper",
        css: this.props.styles.detailsWrapper
      }, typeof this.props.children === 'function' ? this.props.children(this.handleChangeComplete) : this.props.children);
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      if (this.props.children) {
        return jsx(React.Fragment, null, this.props.label, jsx(ScreenReaderContent, null, this.props.showMore ? t('Expanded') : t('Collapsed')));
      }
      return this.props.label;
    }
  }, {
    key: "renderContents",
    value: function renderContents() {
      return jsx(React.Fragment, null, jsx(Checkbox, {
        checked: this.props.isChecked,
        "data-automation": this.props.automationData,
        label: this.getLabel(),
        onChange: this.handleChange,
        value: this.props.value,
        variant: "toggle"
      }), jsx("div", {
        "aria-live": "polite"
      }, this.renderChildren()));
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.isListItem ? jsx("li", {
        css: this.props.styles.listItem
      }, this.renderContents()) : jsx(View, {
        as: "div",
        margin: "0 0 small 0"
      }, this.renderContents());
    }
  }]);
}(Component);
_BaseSetting = BaseSetting;
_defineProperty(BaseSetting, "displayName", 'Setting');
_defineProperty(BaseSetting, "componentId", "Quizzes".concat(_BaseSetting.displayName));
_defineProperty(BaseSetting, "propTypes", {
  addSuccess: PropTypes.func.isRequired,
  automationData: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.func]),
  isChecked: PropTypes.bool.isRequired,
  label: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  showMore: PropTypes.bool,
  styles: PropTypes.object,
  value: PropTypes.string,
  isListItem: PropTypes.bool
});
_defineProperty(BaseSetting, "defaultProps", {
  automationData: null,
  children: null,
  showMore: false,
  value: 'true',
  isListItem: true
});
export var Setting = withStyleOverrides(generateStyle, generateComponentTheme)(BaseSetting);
export default Setting;